import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { List, Select, Radio, Alert } from 'antd';
import PageTitle from '../../../components/PageTitle';
import { COUNTRIES_SUPPORTED  } from '../../../config';
import Error from '../../../components/Error';
import { useShippingRoutes } from '../../../utils/shippingRouteHelper';
import './index.css';
import ShippingRouteCard from './ShippingRouteCard';
import { ShipmentType } from '../../../utils/types';

function useURLQuery() {
  return new URLSearchParams(useLocation().search);
}

type RouteType = 'GROUP' | 'DIRECT';

function ShippingServices() {
  const query = useURLQuery();

  const defaultCountry = 'US';
  const defaultType = 'GROUP';
  const defaultShipmentType = 'REGULAR';

  const country = query.get('c') || defaultCountry;
  const type: RouteType = query.get('t') as RouteType || defaultType;
  const shipmentType = query.get('s') as ShipmentType || defaultShipmentType;

  const history = useHistory();

  function updateURL(param: {country?: string, type?: RouteType, shipmentType?: ShipmentType}) {
    const queryParams: string[] = [];
    const newCountry = param.country ?? country;
    if (newCountry !== defaultCountry) {
      queryParams.push(`c=${newCountry}`);
    }
    const newType = param.type ?? type;
    if (newType !== defaultType) {
      queryParams.push(`t=${newType}`);
    }
    const newShipmentType = param.shipmentType ?? shipmentType;
    if (newShipmentType !== defaultShipmentType) {
      queryParams.push(`s=${newShipmentType}`);
    }
    history.replace(`?${queryParams.join('&')}`);
  }

  const { loading, error, data = { shippingRoutes: [] } } = useShippingRoutes();

  if (error) return <Error />;

  const routes = data.shippingRoutes.filter(r =>
    (r.country === country) &&
    (r.shipmentType === shipmentType || r.shipmentType === 'BOTH') &&
    (type === 'GROUP' ? r.canGroup === true : true) &&
    (type === 'DIRECT' ? r.canDirect === true : true)
  );

  return (
    <div className="ShippingServices">
      <PageTitle>线路渠道</PageTitle>

      <div style={{ marginBottom: '10px' }}>
        <Select size="small" style={{ width: 90 }} onChange={(country) => updateURL({ country })} value={country} >
          {Object.entries(COUNTRIES_SUPPORTED).map(([code, name]) => (
            <Select.Option key={code} value={code}>{name}</Select.Option>
          ))}
        </Select>

        <Radio.Group size="small" style={{ margin: '0 10px' }} value={type} onChange={(e) => updateURL({ type: e.target.value as RouteType})}>
          <Radio.Button value="GROUP">拼邮</Radio.Button>
          <Radio.Button value="DIRECT">直邮</Radio.Button>
        </Radio.Group>

        <Radio.Group size="small" style={{ margin: '0 10px' }} value={shipmentType} onChange={(e) => updateURL({ shipmentType: e.target.value as ShipmentType })}>
          <Radio.Button value="REGULAR">普货</Radio.Button>
          <Radio.Button value="FOOD">敏感</Radio.Button>
        </Radio.Group>
      </div>

      <Alert
        showIcon
        type="warning"
        message="有疑问的话可以微信咨询你的操作员。仓库打包时若发现有违禁品，会移出订单并备注"
        style={{ marginBottom: '1rem' }}
      />

      <List
        loading={loading}
        grid={{ gutter: 16, column: 1 }}
        dataSource={routes}
        rowKey="id"
        renderItem={(route) => (
          <List.Item>
            <ShippingRouteCard route={route} isGroup={type === 'GROUP'} />
          </List.Item>
        )}
      />

    </div>
  );
}

export default ShippingServices;
